module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Weinschiff.d10bfc20.svg";